<template>
  <v-app>
    <UpdatingVersionOverlay v-if="isVersionUpdating" />
    <v-alert
      class="app-alert"
      v-show="alertaGeral.isVisivel"
      border="right"
      dismissible
      shaped
      transition="slide-x-transition"
      :type="alertaGeral.tipo"
    >
      {{ alertaGeral.mensagem }}
    </v-alert>
    <div class="d-flex flex-column app-wrap">
      <AppBar v-if="!$route.meta.hideLayout" />

      <div class="d-flex flex-row flex-grow-1 lateral-wrap">
        <MenuLateral v-if="!$route.meta.hideLayout" />
        <router-view />
      </div>
      <CookiesModuleComponent />
    </div>
  </v-app>
</template>

<script>
import { store } from 'pioneira-ui';
import { mapState, mapActions } from 'vuex';
import AppBar from '@/components/AppBar.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import UpdatingVersionOverlay from '@/components/common/UpdatingVersionOverlay.vue';
import CookiesModuleComponent from './components/CookiesModuleComponent.vue';

export default {
  components: {
    AppBar,
    MenuLateral,
    UpdatingVersionOverlay,
    CookiesModuleComponent,
  },
  data() {
    return {
      timeInterval: null,
      isVersionUpdating: false,
    };
  },
  computed: {
    ...mapState('ModuleAlertas', ['alertaGeral']),
  },
  created() {
    process.env.VUE_APP_ENVIRONMENT === 'production' &&
      this.activateGtm(window, document, 'script', 'dataLayer', 'GTM-KRZWD78N');
  },
  mounted() {
    this.proceedValidateFrontendVersion();
    this.proceedValidateToken();
  },
  destroyed() {
    clearInterval(this.timeInterval);
  },
  methods: {
    ...mapActions('ModuleUsuario', ['forceUserTokenValidation']),
    ...mapActions('ModuleConfig', ['getFrontendVersion']),

    activateGtm(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    },

    isTokenExpired(token) {
      if (token) {
        try {
          const decodeToken = JSON.parse(
            Buffer.from(token.split('.')[1], 'base64').toString()
          );
          return decodeToken.exp < Math.round(new Date().getTime() / 1000);
        } catch (error) {}
      }
      return;
    },

    proceedValidateToken() {
      this.timeInterval = setInterval(() => {
        if (
          this.$route.name !== 'Login' &&
          this.isTokenExpired(store.getters.token)
        ) {
          this.forceUserTokenValidation();
        }
      }, 10000);
    },

    async validateFrontendVersion() {
      if (this.$route.name !== null && this.$route.name !== 'CafMobile') {
        const clientVersion = localStorage.getItem('parceiroVersion');
        const { data } = await this.getFrontendVersion();

        if (data && clientVersion !== data) {
          this.isVersionUpdating = true;
          localStorage.setItem('parceiroVersion', data);
          window.location.reload();
        }
      }
    },

    proceedValidateFrontendVersion() {
      this.validateFrontendVersion();

      window.onfocus = () => {
        this.validateFrontendVersion();
      };
    },
  },
};
</script>

<style lang="scss">
::-webkit-scrollbar-thumb {
  border: 5px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 100px;
  background-color: #ccc;
}

.app-wrap {
  height: 100vh;
  position: relative;
  overflow: hidden;
  background-color: var(--v-neutral-base);
}

.app-alert {
  position: fixed;
  right: 80px;
  top: 75px;
  z-index: 300;
}

.lateral-wrap {
  overflow: hidden;
}
</style>
